/**
 * description 共享稿库详情页
 * created by he.zhikai
 * created on 2017-12-14
 */
'use strict';
angular.module('resourceCenterGxgkDetailModule', []).controller('resourceCenterGxgkDetailCtrl', [
    '$scope',
    '$q',
    '$state',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'resourceCenterService',
    'resCtrModalService',
    'localStorageService',
    'storageListenerService',
    'trsPrintService',
    'editCenUploadVideoForXjService',
    'previewService',
    'mediaIconObj',
    'shareDocApiService',
    'editcenterRightsService',
    'editingMediatypeToPlat',
    function (
        $scope,
        $q,
        $state,
        $timeout,
        trsHttpService,
        modalDialog,
        resourceCenterService,
        resCtrModalService,
        localStorageService,
        storageListenerService,
        trsPrintService,
        editCenUploadVideoForXjService,
        previewService,
        mediaIconObj,
        shareDocApiService,
        editcenterRightsService,
        editingMediatypeToPlat
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                picsModelShow: true,
                isVirtual: false, // 默认当前不是基础稿
                fromsearch: $state.params.fromsearch,
                methodname: {
                    1: 'getNewsShareDoc',
                    2: 'getPicsShareDoc',
                    4: 'getLinkShareDoc',
                    7: 'getVideoShareDoc',
                    8: 'getLiveShareDoc',
                },
                comefrom: 'source.sharedoc',
                isFromPictures: !!(angular.isDefined($state.params.frompictures) && $state.params.frompictures === 'true'), // 稿件来自图片库时不显示取稿按钮
                listOpen: 'processView', // 默认选中的属性信息
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: true, // 作者信息
                    videosInfo: true, // 视频信息
                    keywordInfo: true, // 关键字
                    abstractInfo: true, // 摘要
                    remarksInfo: true, // 备注
                    mcnInfo: true, // mcn/ugc信息
                },
                tabs: {
                    author: true, // 作者信息
                },
                atlas: false, // 图集展开
                doctype: $state.params.type, // 稿件类型
                isUGC: $state.params.isugc === 'true', // 是否是ugc稿件
                previewBigFace: {
                    status: false,
                }, // 是否查看痕迹
                isGxgk: true // 因为图集组件是公用的，但是再取签流程上，共享稿库与其他的地方有些不一样
            };
            $scope.videos = []; // 视频信息
            $scope.data = {
                iconObj: mediaIconObj.iconObj,
                printResult: [], // 打印结果
                keywordsArray: [], // 关键词数组
                groupProcess: {
                    // 集团取签流程
                    medias: [], // 媒体列表
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                    process: [], // 取签流程
                    selectedMedia: '', // 选中的产品
                    navs: [],
                    processData: []
                },
                authorInfo: {
                    // 作者信息
                    authorList: [], // 作者信息列表
                },
                // 融合
                navs: [],
                selectedNav: '',
            };
            $scope.params = {};
            getChannel();
            if (!$scope.status.isUGC) {
                getPubInfo();
            }
            headPortrait();
        }

        /**
         * [getPubInfo description]  获取 作者 编辑 来源等公共信息
         * @return {[type]} [description]
         */
        function getPubInfo() {
            if ($state.params.type !== '8') {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: $scope.status.methodname[$state.params.type],
                    MetaDataId: $state.params.metadataid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.publicInfo = data;
                });
            }
        }

        /**
         * [getChannel description] 获取关联渠道
         * @return {[type]} [description]
         */
        function getChannel() {
            if ($state.params.type !== '8') {
                $scope.data.navs.push({
                    MEDIANAME: '基础稿',
                    MEDIATYPE: '-1',
                    routerName: 'iwopreview',
                });
            }
            getBindingMediaIds($state.params.metadataid).then(function (bingdingData) {
                angular.forEach(bingdingData, function (value, key) {
                    if (value.MEDIATYPE === '1') {
                        $scope.data.navs.push({
                            // ggg
                            MEDIANAME: value.MEDIANAME,
                            MEDIATYPE: value.MEDIATYPE,
                            routerName: 'appPreview',
                        });
                    } else if (value.MEDIATYPE === '2') {
                        $scope.data.navs.push({
                            MEDIANAME: value.MEDIANAME,
                            MEDIATYPE: value.MEDIATYPE,
                            routerName: 'websitePreviewAll',
                        });
                    } else if (value.MEDIATYPE === '3') {
                        $scope.data.navs.push({
                            MEDIANAME: value.MEDIANAME,
                            MEDIATYPE: value.MEDIATYPE,
                            routerName: 'newspaperNewsPreview',
                        });
                    } else if (value.MEDIATYPE === '4') {
                        $scope.data.navs.push({
                            MEDIANAME: value.MEDIANAME,
                            MEDIATYPE: value.MEDIATYPE,
                            routerName: 'weixinPreview',
                        });
                    } else if (value.MEDIATYPE === '5') {
                        $scope.data.navs.push({
                            MEDIANAME: value.MEDIANAME,
                            MEDIATYPE: value.MEDIATYPE,
                            routerName: 'weiboPreview',
                        });
                    }
                });
                selectNav($scope.data.navs[0]);
            });
        }

        /**
         * [selectNav description]   选择导航
         * @param  {[type]} nav [description]
         * @return {[type]}     [description]
         */
        $scope.selectNav = function (nav) {
            selectNav(nav);
        };

        /**
         * [selectNav description]
         * @param   {[type]}  nav  [nav description]
         * @return  {[type]}       [return description]
         */
        function selectNav(nav) {
            $scope.data.selectedNav = nav;
            $scope.params = switchParams(nav);
            requestData();
            initQqjccInfos();
        }

        /**
         * [switchParams description] 切换参数方法
         * @param   {[type]}  nav  [nav description]
         * @return  {[type]}       [return description]
         */
        function switchParams(nav) {
            let params;
            let plat = editingMediatypeToPlat[nav.MEDIATYPE * 1];
            switch (plat) {
                case 'iwo':
                    params = {
                        serviceid: 'mlf_myrelease',
                        methodname: $scope.status.methodname[$state.params.type],
                        MetaDataId: $state.params.metadataid,
                    };
                    break;
                case 'app':
                    params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'getAPPFusionDoc',
                        sourceDocId: $state.params.metadataid,
                    };
                    break;
                case 'newspaper':
                    params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'getPaperFusionDoc',
                        sourceDocId: $state.params.metadataid,
                    };
                    break;
                case 'website':
                    params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'getWebFusionDoc',
                        sourceDocId: $state.params.metadataid,
                    };
                    break;
                case 'weixin':
                    params = {
                        serviceid: 'mlf_fusionwechat',
                        methodname: 'getVirtualNewsDoc',
                        sourceDocId: $state.params.metadataid,
                    };
                    break;
                case 'weibo':
                    params = {
                        serviceid: 'mlf_fusionmicroblog',
                        methodname: 'getScmVirtualNewsDoc',
                        sourceDocId: $state.params.metadataid,
                    };
                    break;
            }
            params.catId = $state.params.nodeid;
            return params;
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [metadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(metadataid) {
            var defer = $q.defer();
            let params;
            if ($scope.status.isUGC) {
                params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappingsForUgc',
                    UgcId: metadataid,
                    mediaTypes: '',
                };
            } else {
                params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappings',
                    sourceDocId: metadataid,
                    mediaTypes: '',
                };
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            if ($scope.status.isUGC) {
                $scope.params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'queryArticles',
                    Method: 'articleInfo',
                    ID: $state.params.metadataid,
                };
            }
            delete $scope.forAtlas; // 使trs-slider重新加载
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                if ($scope.status.isUGC) {
                    $scope.detailInfos = data.data[0].article;
                    $scope.detailInfos.METADATAID = data.data[0].article.id;
                    $scope.detailInfos.ORIGINMETADATAID = data.data[0].article.id;
                    $scope.detailInfos.DOCTYPEID = data.data[0].article.docType;
                    $scope.detailInfos.NEWSSOURCES = data.data[0].article.articlePublishDept;
                    $scope.detailInfos.SIGNATUREAUTHOR = data.data[0].article.cruser;
                    $scope.detailInfos.SHAREOPERUSERTRUENAME = data.data[0].article.cruser;
                    $scope.detailInfos.CRTIME = data.data[0].article.crtime;
                    $scope.detailInfos.FLOWVERSIONTIME = data.data[0].article.crtime;
                    $scope.detailInfos.TITLE = data.data[0].article.articleTitle;
                    $scope.detailInfos.DOCWORDSCOUNT = data.data[0].article.articleWordsCount;
                    $scope.detailInfos.HTMLCONTENT = data.data[0].article.articleHtmlCon;
                    $scope.status.audioVideoidsArray = data.data[0].videoUrlList.concat(data.data[0].audioUrlList);
                    $scope.detailInfos.USERNAME = data.data[0].user.truename;
                    $scope.detailInfos.UNIT = data.data[0].user.unit;
                    $scope.detailInfos.MOBILE = data.data[0].user.mobile;
                    $scope.detailInfos.REMARK = data.data[0].article.remark;
                    $scope.detailInfos.POSTALCODE = data.data[0].user.postalCode;
                    $scope.detailInfos.DOC_PICTURELIST = data.data[0].picUrlList.map((item) => ({
                        PERPICURL: item.url,
                        SRCPICURL: item.url,
                        APPDESC: item.picDesc,
                    }));
                    $scope.detailInfos.VIDEOREL = [
                        {
                            URL: data.data[0].videoUrlList[0].url,
                            AUDIOVIDEOID: data.data[0].videoUrlList[0].audioVideoId
                        }
                    ];
                    angular.forEach($scope.status.audioVideoidsArray, function (value, key) {
                        value.AUDIOVIDEOID = value.qiniuId;
                        value.STORAGE = '2';
                    });
                } else {
                    var items = data;
                    if (angular.isUndefined(data.HTMLCONTENT)) {
                        data.DOCWORDSCOUNT = data.CONTENT.length;
                        data.HTMLCONTENT = data.CONTENT.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;');
                    }
                    if ($scope.params.methodname === 'getPaperFusionDoc') {
                        items = data;
                    }
                    $scope.detailInfos = items;
                    $scope.detailInfos.DOCSHAREMEDIA = $scope.detailInfos.DOCSHAREMEDIA ? $scope.detailInfos.DOCSHAREMEDIA.split(',') : [];
                    $scope.data.item = {
                        REMARKS: items.REMARKS,
                        BGAPPENDIX: items.BGAPPENDIX
                    };
                    $scope.forAtlas = angular.copy(items);
                    $scope.data.keywordsArray = !items.KEYWORDS ? [] : items.KEYWORDS.split(';');
                    if ($state.params.type === '7') {
                        getVideoUrl(items);
                    }
                    if ($state.params.type === '8') {
                        getLiveInfo();
                    }
                    previewService.drawVideoMark(false, true);
                }
                $scope.status.isVirtual = editingMediatypeToPlat[$scope.detailInfos.MEDIATYPE] === 'virtual';
                if (!$scope.status.isVirtual && !$scope.status.isUGC) { // 虚拟稿&&UGC稿件不请求
                    editcenterRightsService.operManuscriptRight($scope.detailInfos).then(function (rights) {
                        $scope.status.rights = rights; // 用于判断是否可编辑
                    });
                }

                /**
                 * [getLiveInfo description]  直播稿共享信息
                 * @return {[type]} [description]
                 */
                function getLiveInfo() {
                    var params = {
                        MetaDataId: $state.params.metadataid,
                        methodname: 'getLiveShareDoc',
                        serviceid: 'mlf_myrelease',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (_data) {
                        $scope.detailInfos.SHAREUSEPATH = _data.SHAREUSEPATH;
                        $scope.detailInfos.SHAREOPERUSERTRUENAME = _data.SHAREOPERUSERTRUENAME;
                    });
                }
            });
        }

        /**
         * [getVideoUrl description]
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function getVideoUrl(data) {
            editCenUploadVideoForXjService.getVideoMark($scope.detailInfos.VIDEOREL[0]).then(function (data) {
                $scope.detailInfos.VIDEOREL[0].URL = data.videoUrl; // 回填URL
            });
        }

        /**
         * [initQqjccInfos description] 初始化取签见撤重信息
         * @return {[type]} [description]
         */
        function initQqjccInfos() {
            getQqjccChannel();
            getQqjccInfo();
        }

        /**
         * [getQqjccChannel description] 获取取签见撤重媒体
         * @return {[type]} [description]
         */
        function getQqjccChannel() {
            var params;
            if ($scope.status.isUGC) {
                return;
            } else {
                params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryOperMedias',
                    MetaDataId: $state.params.metadataid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.groupProcess.medias = [
                        {
                            MEDIANAME: '全部',
                            MEDIATYPE: '',
                            MEDIAID: '',
                        },
                    ].concat(data);
                    $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
                });
            }
        }

        /**
         * [getQqjccInfo description] 获取取签见撤重信息
         * @return {[type]} [description]
         */
        function getQqjccInfo() {
            var params;
            if ($scope.status.isUGC) {
                params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'queryFlagList',
                    UgcId: $state.params.metadataid,
                };
            } else {
                params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryOperations',
                    MetaDataId: $state.params.metadataid,
                    mediaid: $scope.data.groupProcess.selectedMedia.MEDIAID,
                    mediatype: $scope.data.groupProcess.selectedMedia.MEDIATYPE,
                };
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if ($scope.status.isUGC) {
                    // $scope.data.groupProcess.process = data;
                    dealOperListData(data);
                    $scope.ugcGroupProcessLength = 0;
                    angular.forEach($scope.data.groupProcess.process, function (value, key) {
                        $scope.ugcGroupProcessLength += value.length;
                    });
                } else {
                    $scope.data.groupProcess.process = data.OPERS;
                }
                if ($scope.data.groupProcess.process.length > 1) {
                    $('.resource_detail .groupProcess_process').css('height', ($scope.data.groupProcess.process.length - 1) * 120 + 'px');
                } else if ($scope.ugcGroupProcessLength > 1) {
                    var winWide = window.screen.width,
                        totalLength;
                    if (winWide <= 1400) {
                        totalLength = $scope.ugcGroupProcessLength + 1;
                    } else {
                        totalLength = $scope.ugcGroupProcessLength;
                    }
                    $('.resource_detail .groupProcess_process').css('height', totalLength * 120 + 'px');
                } else {
                    $('.resource_detail .groupProcess_process').css('height', '0px');
                }
            });
        }

        /**
         * [selectQqjccChannel description] 选择取签见撤重媒体
         * @param  {[type]} media [description] 当前媒体
         * @return {[type]}       [description]
         */
        $scope.selectQqjccChannel = function (media) {
            $scope.data.groupProcess.selectedMedia = media;
            if ($scope.status.isUGC) {
                getQqjccInfoByMedia(media);
            } else {
                getQqjccInfo();
            }
        };

        /**
         * [getQqjccInfoByMedia 获取某个渠道下的取签见撤重记录]
         *
         * @param   {[type]}  media  [media description]
         *
         * @return  {[type]}         [return description]
         */
        function getQqjccInfoByMedia(media) {
            if (media.MEDIANAME === '全部') {
                $scope.data.groupProcess.process = $scope.data.groupProcess.processData;
            } else {
                $scope.data.groupProcess.process = $scope.data.groupProcess.processData.filter((item) => item.MEDIANAME === media.MEDIANAME);
            }
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function (direction) {
            var pageTurningData = JSON.parse(localStorageService.get('fusiongxgPreview'));
            var node = localStorageService.get('fusiongxgPreviewNode');
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].METADATAID === $state.params.metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                metadataid: toPageData.METADATAID,
                type: toPageData.DOCTYPEID,
                nodeid: node,
            }, {
                reload: true
            });
        };

        /**
         * [contentResize description] 设置左右侧高度一样
         * @return {[type]} [description]
         */
        $scope.contentResize = function () {
            $timeout(function () {
                var $father = $('.resource_detail');
                var $left = $father.find('.resource_detail_article');
                var $right = $father.find('.resource_detail_relatedInfo');
                var leftHeight = $left.height();
                $right.height(leftHeight);
                $left.resize(function (event) {
                    var leftHeight = $left.height();
                    $right.height(leftHeight);
                });
            });
        };

        /**
         * [openOriginalPic description] 查看完整图片
         * @param  {[type]} url [description] 图片地址
         * @return {[type]}     [description]
         */
        $scope.openOriginalPic = function (url) {
            window.open(url);
        };

        /* 稿件操作开始*/
        /**
         * [collect description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function () {
            if ($state.params.type != 1 && $state.params.type != 2) {
                modalDialog.alertType('只能收藏新闻和图集', '', 'warning', 'confirm', '');
                return;
            }
            var params;
            if ($scope.status.isUGC === true) {
                params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'collectUgcDoc',
                    Method: 'articleInfo',
                    ID: $state.params.metadataid,
                };
            } else {
                params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'collect',
                    MetaDataIds: $state.params.metadataid,
                };
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /**
         * [creationAxis description] 个人素材
         * @return {[type]} [description]
         */
        $scope.creationAxis = function () {
            var params;
            if ($state.params.isugc === 'true') {
                params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'createCreations',
                    Method: 'articleInfo',
                    id: $state.params.metadataid,
                };
            } else {
                params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'addPersonalMaterialOfTxt',
                    PersonalMaterialId: '0',
                    MetaDataId: $state.params.metadataid,
                    mediaType: $scope.data.selectedNav.MEDIATYPE,
                };
            }
            resourceCenterService.setBigDataCreation(params).then(function (data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [openTakeDraftModal description]
         * @param   {[type]}  from  [from description]
         * @return  {[type]}        [return description]
         */
        $scope.openTakeDraftModal = function (from) {
            var detailData = [
                {
                    DOCTYPEID: $scope.detailInfos.DOCTYPEID,
                    METADATAID: $scope.detailInfos.METADATAID,
                    relatedMedias: angular.copy($scope.data.navs), // 加入此参数的目的是为了方便判断稿件有没有融合微博，取稿弹窗内是否应该展示微博
                },
            ];
            var params = {};
            if ($scope.status.isUGC) {
                params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'takeArticle',
                    Method: 'takeArticle',
                    ID: $state.params.metadataid,
                    SourceName: '资源中心-共享稿库-' + $scope.detailInfos.SOURCENAME,
                };
            } else {
                params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodname: 'fetch',
                    MetaDataIds: $state.params.metadataid,
                    SourceName: '资源中心-共享稿库-' + $scope.detailInfos.SOURCENAME,
                    nodeid: $state.params.nodeid,
                };
            }

            var modalInstance = resCtrModalService.fullTakeDraft(params, true, detailData, $scope.status.isUGC);
            modalInstance.result.then(function () {
                storageListenerService.addListenerToResource('takeDraft');
                // 此处是为了适应图集稿详情页取稿不报错
                if (!from) {
                    initStatus();
                } else {
                    initQqjccInfos();
                }

            });
        };

        /**
         * [commonDeleteDrafts description] 普通删除稿件
         * @return {[type]} [description]
         */
        $scope.commonDeleteDrafts = function () {
            shareDocApiService.commonDeleteDrafts($scope).then(function () {
                storageListenerService.addListenerToResource('takeDraft');
                window.close();
            });
        };

        /**
         * [adminDeleteDrafts description] 管理员删除稿件// 20200608更改为管理员撤稿
         * @return {[type]} [description]
         */
        $scope.adminDeleteDrafts = function () {
            shareDocApiService.adminDeleteDrafts($scope).then(function () {
                storageListenerService.addListenerToResource('takeDraft');
                window.close();
            });
        };

        /**
         * [printBtn description] 打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function () {
            var params = switchParams($scope.data.selectedNav);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                data = angular.isArray(data) ? data : [data];
                if ($scope.data.selectedNav.MEDIATYPE == -1) {
                    trsPrintService.trsIwoPrintDocument(data);
                } else if ($scope.data.selectedNav.MEDIATYPE == 1) {
                    trsPrintService.trsAppPrintDocument(data);
                } else if ($scope.data.selectedNav.MEDIATYPE == 2) {
                    trsPrintService.trsWebPrintDocument(data);
                } else if ($scope.data.selectedNav.MEDIATYPE == 3) {
                    trsPrintService.trsPrintDocument(data);
                } else if ($scope.data.selectedNav.MEDIATYPE == 4) {
                    trsPrintService.trsWeixinPrintDocument(data);
                }
            });
        };


        /**
         * [openAtlas description] 收起图集
         * @param  {[type]} state [description] boolean
         * @return {[type]}       [description]
         */
        $scope.openAtlas = function (state) {
            delete $scope.forAtlas;
            $scope.forAtlas = angular.copy($scope.detailInfos);
            $scope.status.atlas = state;
        };

        /**
         * [headPortrait description] 获取头像
         * @return {[type]} [description]
         */
        function headPortrait() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
        * [bigFace description] 查看痕迹
        * @return {[type]} [description]
        */
        $scope.bigFace = function () {
            if ($scope.detailInfos.DOCTYPEID === '2') {
                $scope.status.picsModelShow = !$scope.status.picsModelShow;
            }
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };

        /**
         * [dealOperListData 处理本媒体取签记录数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealOperListData(data) {
            $scope.data.groupProcess.medias.push({
                MEDIANAME: '全部'
            });
            if (data.QU && data.QU.length) {
                setOperFlagMedia(data.QU);
            }
            if (data.QIAN && data.QIAN.length) {
                setOperFlagMedia(data.QIAN);
            }
            if (data.JIAN && data.JIAN.length) {
                setOperFlagMedia(data.JIAN);
            }
            if (data.CHE && data.CHE.length) {
                setOperFlagMedia(data.CHE);
            }
            if (data.CHONG && data.CHONG.length) {
                setOperFlagMedia(data.CHONG);
            }
            $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
        }

        /**
         * [setOperFlagMedia 设置本媒体取签的媒体列表]
         *
         * @param   {[type]}  data  [data 取签见撤记录]
         * @param   {[type]}  type  [data 取签见撤类型]
         *
         * @return  {[type]}        [return description]
         */
        function setOperFlagMedia(data, type) {
            data.forEach((item) => {
                var media = {
                    MEDIANAME: item.MEDIANAME
                };
                if (mediaNotExsit(media)) {
                    $scope.data.groupProcess.medias.push(media);
                }
                $scope.data.groupProcess.process.push(item);
                $scope.data.groupProcess.processData.push(item);
            });
        }

        /**
         * [mediaNotExsit 判断取签见撤媒体列表中是否已经存在目标媒体]
         *
         * @param   {[type]}  media  [media 目标媒体]
         *
         * @return  {[type]}         [return description]
         */
        function mediaNotExsit(media) {
            return JSON.stringify($scope.data.groupProcess.medias).indexOf(media.MEDIANAME) === -1;
        }

    },
]);
